import { useMutation } from '@tanstack/react-query';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { RcFile } from 'antd/es/upload';
import { expand } from 'uri-template-lite';

interface IArgs {
  file: string | Blob | RcFile;
  id?: number;
  replace?: boolean;
}

export const useMutateAlgorithmsUpload = (
  onProgress?: (progress: number) => void,
) =>
  useMutation<string, ApiErrorResponse, IArgs>({
    mutationKey: ['algorithmsUpload'],
    mutationFn: async ({ file, id, replace }) => {
      await apiClient.post(
        expand(DataObjectDescriptionVersionUrl.uploadAlgorithms, {
          id,
          replace,
        }),
        {
          file,
        },
        {
          headers: { 'content-type': 'multipart/form-data' },
          onUploadProgress: (progress) => {
            if (!progress.total) {
              return;
            }
            onProgress?.((progress.loaded / progress.total) * 100);
          },
        },
      );
      return 'success';
    },
  });
